import { z } from 'zod';

export const csvStringArrayValidator = z.string().refine(
  value => {
    if (typeof value !== 'string') return false;
    const parts = value.split(',');
    return parts.every(part => part.trim() !== ''); // Ensure no empty parts after splitting
  },
  {
    message: 'Value must be a valid comma-separated string',
  },
);
